import { defineComponent, inject, provide, ref } from 'vue';
import type { Component } from 'vue';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { IncentiveStep } from '../../../../interfaces/enums/incentive-step';
import Registration from '../components/Registration/Registration.vue';
import EmailRegistration from '../components/Registration/EmailRegistration/EmailRegistration.vue';
import LoginForm from '../components/LoginForm/LoginForm.vue';
import ForgotPassword from '../components/ForgotPassword/ForgotPassword.vue';
import OptInV2 from '../components/OptIn/OptInV2.vue';
import CPI from '../components/CPI/CPI.vue';
import DynamicHtmlSlot from '../DynamicHtmlSlot';
import { setupComponent } from "@studyportals/vue-platform";
import BaseTemplate from './BaseTemplate.class';

export interface IncentiveSlots {
	registrationHeader?: Component;
	optInContent?: Component;
	registrationHeaderElement?: HTMLElement;
	optInContentElement?: HTMLElement;
}

export default defineComponent({
	components: { Registration, EmailRegistration, LoginForm, ForgotPassword, OptInV2, CPI, DynamicHtmlSlot },
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		const steps = inject<IncentiveStep[]>('incentiveSteps', []);
		const slots = inject<IncentiveSlots>('incentiveSlots', {});
		const isRegister = ref(false);
		const isForgotPassword = ref(false);

		provide('isRegister', isRegister);
		provide('isForgotPassword', isForgotPassword);

		if (!store) throw new Error('incentiveV2Store was not provided');

		const component = new BaseTemplate(store, steps, slots, isRegister, isForgotPassword);

		return setupComponent(component);
	},
});
